module.exports = __webpack_public_path__ + "img/icon_sm_yszktjhlj.4289cfce.png";